import React from 'react';
import { Select } from 'antd';
const { Option } = Select;

const TablePageSize = ({ pages, changePageSize }) => {
  return (
    <div className="pages-count">
      <div className="pages-count__content">
        <span className="pages-count__title">Показать на странице</span>
        <Select
          value={pages}
          getPopupContainer={trigger => trigger.parentNode}
          style={{ width: 80 }}
          onChange={changePageSize}
        >
          <Option value={3}>3</Option>
          <Option value={5}>5</Option>
          <Option value={10}>10</Option>
        </Select>
      </div>
    </div>
  );
};

export default TablePageSize;
